module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-1', 'mod-benefits',
      _vm.meanList[2].clicked ? 'pt-page-current' : '',
      _vm.meanList[2].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[2].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-benefits"
    }
  }, [_c('div', {
    class: ['mod-section-benefits', _vm.pageClass.pageNow]
  }, [_c('div', {
    class: ["inner-section", "content-first", "slide", "",
      _vm.currentBoolean.isTwo ? "pt-page-moveToLeft" : "",
      _vm.currentBoolean.isOne ? "pt-page-scaleUp pt-slide-current" : ""
    ]
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    class: ["inner-section", "content-second", "slide",
      _vm.currentBoolean.isTwo ? "pt-page-scaleUp pt-slide-current" : "",
      _vm.currentBoolean.isOne ? "pt-page-moveToRight" : "",
      _vm.currentBoolean.isThree ? "pt-page-moveToLeft" : ""
    ]
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    class: ["inner-section", "content-third", "slide",
      _vm.currentBoolean.isThree ? "pt-page-scaleUp pt-slide-current" : ""
    ]
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "benefits-nav"
  }, [_c('div', {
    staticClass: "benefits-nav-line"
  }, [_c('span', {
    staticClass: "label left"
  }, [_vm._v("简单介绍")]), _vm._v(" "), _c('span', {
    staticClass: "line-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "label middle"
  }, [_vm._v("个人展示")]), _vm._v(" "), _c('span', {
    staticClass: "line-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "label right"
  }, [_vm._v("得意作品")]), _vm._v(" "), _c('span', {
    staticClass: "marker left active",
    on: {
      "click": function($event) {
        _vm.turnPage(0)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "marker middle",
    on: {
      "click": function($event) {
        _vm.turnPage(1)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "marker right",
    on: {
      "click": function($event) {
        _vm.turnPage(2)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('span', {
    staticClass: "arrow arrow-left",
    on: {
      "click": function($event) {
        _vm.turnLeft()
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "/images/icons/benefits-arrow-left.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "arrow arrow-right",
    on: {
      "click": function($event) {
        _vm.turnRight()
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "/images/icons/benefits-arrow-right.png"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("熟练使用各类前端框架")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("目前在用Vue.js、微信小程序")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        运用各类前端框架，根据其优势和不足熟练运用到不同的项目或创业中。"), _c('br'), _vm._v("\n        JavaScript作用于浏览器，熟练使用原生JS、JQuery、Zepto对应插件及框架；JavaScript作用于WebView、内置App，熟练使用Vue、Cordova、微信小程序；JavaScript作用于服务器端，了解Node.js。\n        熟练使用HTML、CSS进行页面的制作，酷炫复杂自定义动画不会。\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("我是要成为")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("海贼王的男人。")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        我是出生在一个很普通的农村家庭，从小学会做什么事必须靠自己，如果想要生活得更好，自己就必须加倍的努力。用几个词语形容自己的话，那就是：时尚屌丝、成熟的有点过分、智商超群、情商为零、做事认真负责、向往自由…\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("App：一起玩吧")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("网站：个人博客")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        一起玩吧：以玩会友，人这辈子真心朋友不多，希望通过该App能让大家找到真心朋友。"), _c('br'), _vm._v("\n        博客：自己的练级之地，除了前端技术方面，还有生活、健身、自己的思想等各个方面。\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "active-marker"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "/images/icons/benefits-marker-active.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8c8efac!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/page/Advantage.vue
// module id = 244
// module chunks = 0